import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {Add_ImgPub, isAuthenticated, userPub, deleteImgPub } from "../auth";
import imgLakay from "../Layout/imgs/Untitled-2.jpg";
import imgProductLakay from "../Layout/imgs/md3.jpg";
import { getLakayUser } from "../auth/apiProduct";
import Userpubgallery from "./Userpubgallery";
import { elakay_API, toImageUrl, getElakayImageLoadUrl } from "../../config";

import { MdDeleteForever, MdEdit, MdRemoveRedEye, MdClose } from "react-icons/md";
import { FaDesktop, FaMobileAlt } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import useElakaySwiper from "../slider/swiperSettings/useElakaySwiper";
import ElakayAccount from "../Layout/imgs/Elakay-account-1.png";
import RoyaltyUser from "../Layout/imgs/Royalty-user-1.png";
import SellerPub1 from "../Layout/imgs/Seller-pub-1.png";
import { Family } from "../pageInside/Rolle";
import ErrorAlert from "../pageInside/ErrorAlert";
import "./imagesLoading.css";
import "./PubUploadForm.css";
import { elakayAutoText } from "./dataElakay";
import ShopHeroSourcePanel from "../dynamicSwipers/ShopHeroSourcePanel";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addPubShop"]?.[key] || fallback;

const PUB_SHOP_SECTIONS = [
  { slug: "pub-follower", refIndex: 1 },
  { slug: "pub-category", refIndex: 2 },
  { slug: "btn-image-admin", refIndex: 3 },
  { slug: "pub-follow-images", refIndex: 4 },
  { slug: "slider-shop", refIndex: 5 },
];

const PubShop = (props) => {
  const {
    imgSize = 0,
    laguangeElakay,
    infoSource,
    userID,
    activeSection = "slider-shop",
    onSectionChange = () => {},
  } = props;
  __setElakayInfoSource(infoSource);
  const { userInfo } = infoSource;
  const { token } = isAuthenticated();

  const [getUserPub, setUserPub] = useState([]);
  const [longPub, setlongPub] = useState(0);
  const [getCategoriesUser, setCategoriesUser] = useState([]);
  const [error, setError] = useState(null);
  const [viewImageModal, setViewImageModal] = useState(null);
  const [editImageIndex, setEditImageIndex] = useState(null);
  const [highlight, setHighlight] = useState(false);

  // ✅ Configuration pub avec refIndex
  const [pubInfo, setPubInfo] = useState({
    nameref: "sliderShop",
    maxImgSize: 3,
    refIndex: 5,
    catID: "",
  });

  const [post, setPost] = useState({
    catID: "",
    photos: [],
  });

  const maxTailleImg = 1500 * 857;
  const { photos, catID } = post;
  const sizeImg = (photos?.length || 0) + (imgSize !== 0 ? imgSize : longPub || 0);

  const imagesize = ["imgMa480", "imgMi768", "imgMi1024"];

  const refObjName = [
    __elakayText("t016", "avatar"),
    __elakayText("t017", "Pub Follower"),
    __elakayText("t018", "Pub Category"),
    __elakayText("t019", "Btn Image Admin"),
    __elakayText("t020", "Pub Follow Images"),
    __elakayText("t021", "slider Shop"),
  ];

  const refObj = [
    "avatar",
    "PubImgFollow",
    "PubCategory",
    "viewImagAdmin",
    "viewImagforFollow",
    "sliderShop",
  ];

  // ✅ Mapping refObj → refIndex
  const refObjToIndex = {
    avatar: 0,
    PubImgFollow: 1,
    PubCategory: 2,
    viewImagAdmin: 3,
    viewImagforFollow: 4,
    sliderShop: 5,
  };

  const onlyFamilly = (only) => {
    if (only === "sliderShop") return true;
    if (Family()) return true;
    return false;
  };

  // ✅ Helper functions
  const checkIfAddImg = (nameref) => {
    if (nameref === "PubCategory") return catID === "";
    return !onlyFamilly(nameref);
  };

  const language = (source, type, key) => {
    return source.laguangeElakay(type, source.languageAPI)[key] || key;
  };

  const inputError = (info, isTitle) => (
    <div className="custom-file-drop-area redlight">
      <label htmlFor="filephotos">{isTitle ? <strong style={{ fontSize: "1.1rem" }}>{info}</strong> : info}</label>
    </div>
  );

  useEffect(() => {
    loadingUserPub(userID);
  }, [userID]);

  const loadProductsByArrival = (uid, cid) => {
    getLakayUser(uid, 0, 100, "createdAt", cid)
      .then((data) => {
        setCategoriesUser(data.categories);
      })
      .catch((error) => {
      });
  };

  const loadingUserPub = async (uid) => {
    try {
      const data = await userPub(uid);
      if (!data) return;

      setUserPub(data);

      if (data.sliderShop && Array.isArray(data.sliderShop)) {
        setlongPub(data.sliderShop?.length);
      } else {
        setlongPub(0);
      }
    } catch (error) {
      console.error("Error loading user pub:", error);
    }
  };

  const applySelectedPub = (b) => {
    setPost({ catID: "", photos: [] });

    if (b === 0) return;

    const selectedRef = refObj[b];
    const refIndex = refObjToIndex[selectedRef];

    if (b === 1) {
       setlongPub(getUserPub?.PubImgFollow?.urlImg ? 1 : 0);
      setCategoriesUser([]);
      
      setPubInfo({ nameref: selectedRef, maxImgSize: 1, refIndex, catID: "" });
      return;
    }

    if (b === 2) {
      setlongPub(getUserPub?.PubCategory?.urlImg ? 1 : 0);
      loadProductsByArrival(userInfo._id);
      setPubInfo({ nameref: selectedRef, maxImgSize: 1, refIndex, catID: "" });
      return;
    }
 
    if (b <= 4) {
      setlongPub(getUserPub?.viewImagforFollow?.urlImg ? 1 : 0);
      setCategoriesUser([]);
      setPubInfo({ nameref: selectedRef, maxImgSize: 1, refIndex, catID: "" });
      return;
    }

    if (b === 5) {
      setlongPub(getUserPub?.sliderShop?.length || 0);
      setCategoriesUser([]);
      setPubInfo({ nameref: selectedRef, maxImgSize: 3, refIndex, catID: "" });
      return;
    }
  };

  const handSelectedPub = (refIndex) => {
    const section = PUB_SHOP_SECTIONS.find((item) => item.refIndex === refIndex);
    if (section) onSectionChange(section.slug);
  };

  useEffect(() => {
    const section = PUB_SHOP_SECTIONS.find((item) => item.slug === activeSection)
      || PUB_SHOP_SECTIONS[PUB_SHOP_SECTIONS.length - 1];
    applySelectedPub(section.refIndex);
    // applySelectedPub deliberately resets the upload draft when the URL section changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection, getUserPub]);

  const handSelectedCatId = (catid) => {
    setPost((prev) => ({ ...prev, catID: catid }));
    setPubInfo((prev) => ({ ...prev, catID: catid }));
  };

  const ImageSizeSelector = () => {
    const isDualImage = [3, 4, 5].includes(pubInfo.refIndex);
    if (!isDualImage) return null;

    const desktopCount = photos.filter(p => p.deviseSize === 'd').length;
    const mobileCount = photos.filter(p => p.deviseSize === 'm').length;

    return (
      <div className="pub-size-selector">
        {/* Desktop & Tablet */}
        <div className={`pub-size-badge pub-size-badge--desktop ${desktopCount > 0 ? 'is-active' : ''}`}>
          <FaDesktop />
          <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t001}</span>
          {desktopCount > 0 && (
            <span className="pub-size-count pub-size-count--desktop">{desktopCount}</span>
          )}
        </div>

        {/* Mobile */}
        <div className={`pub-size-badge pub-size-badge--mobile ${mobileCount > 0 ? 'is-active' : ''}`}>
          <FaMobileAlt />
          <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t002}</span>
          {mobileCount > 0 && (
            <span className="pub-size-count pub-size-count--mobile">{mobileCount}</span>
          )}
        </div>

        {/* Edit Button */}
        {photos.length > 0 && (
          <button
            type="button"
            className={`pub-action-btn pub-action-btn--edit ${editImageIndex !== null ? 'is-active' : ''}`}
            onClick={() => setEditImageIndex(editImageIndex === null ? 0 : null)}
          >
            <MdEdit />
            <span>{editImageIndex !== null ? elakayAutoText("h_4d63c1d519408c", "Cancel Edit") : elakayAutoText("h_ce2267a8fe5daf", "Edit Images")}</span>
          </button>
        )}

        {/* View Button */}
        {photos.length > 0 && (
          <button
            type="button"
            className="pub-action-btn pub-action-btn--view"
            onClick={() => setViewImageModal(photos[0])}
          >
            <MdRemoveRedEye />
            <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t003}</span>
          </button>
        )}
      </div>
    );
  };

  const handleFiles = (files) => {
  let arrPhotos = [];
  let filesProcessed = 0;

  // ✅ we allow saving first image even if user makes a mistake
  let errorMessages = []; // collect messages (optional)

  const isDualImage = [3, 4, 5].includes(pubInfo.refIndex);

  const finalize = () => {
    // add whatever is valid
    if (arrPhotos.length > 0) {
      const sizeArr = Math.min(arrPhotos.length, pubInfo.maxImgSize - photos.length);
      setPost((prev) => ({
        ...prev,
        photos: [...prev.photos, ...arrPhotos.slice(0, sizeArr)],
      }));
    }

    // show error if any
    if (errorMessages.length > 0) {
      setError(errorMessages.flat());
    }
  };

  for (let file of files) {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();

      img.onload = () => {
        const naturalW = img.width;
        const naturalH = img.height;

        let detectedDeviseSize = "d";

        // -----------------------------------------
        // 1) Validate dimensions + detect deviceSize
        // -----------------------------------------
        if (isDualImage) {
          if (naturalW === 1200 && naturalH === 500) {
            detectedDeviseSize = "d";
          } else if (naturalW === 800 && naturalH === 500) {
            detectedDeviseSize = "m";
          } else {
            errorMessages.push([
              elakayAutoText("h_de4db34c2c88a9", "❌ Invalid image dimensions. Accepted formats are:"),
              elakayAutoText("h_606d3f63372f4d", "• 1200 x 500 pixels for Desktop & Tablet"),
              elakayAutoText("h_b6dba72766a7db", "• 800 x 500 pixels for Mobile"),
              "",
              elakayAutoText("h_f24a26cc64d41d", "Your image \"{value0}\":", { value0: file.name }),
              elakayAutoText("h_ff9a956c2c1567", "• {value0} x {value1} pixels ❌", { value0: naturalW, value1: naturalH }),
              ""
            ]);
            filesProcessed++;
            if (filesProcessed === files.length) finalize();
            return;
          }

          // -----------------------------------------
          // 2) NEW RULE: if batch tries 2 same sizes
          //    keep first, ignore second, error "add other size"
          // -----------------------------------------
          const alreadyInBatchSameSize = arrPhotos.some(p => p.deviseSize === detectedDeviseSize);
          const alreadyInExistingSameSize = photos.some(p => p.deviseSize === detectedDeviseSize);

          if (alreadyInBatchSameSize || alreadyInExistingSameSize) {
            const need = detectedDeviseSize === "d"
              ? elakayAutoText("h_b97c18a15cd3b9", "Mobile (800 x 500)")
              : elakayAutoText("h_e37f093b6d5762", "Desktop (1200 x 500)");
            const currentDesktop = [...photos, ...arrPhotos].filter(p => p.deviseSize === "d").length;
            const currentMobile = [...photos, ...arrPhotos].filter(p => p.deviseSize === "m").length;

            errorMessages.push([
              elakayAutoText("h_58eba3b8653e63", "⚠️ You selected 2 images with the SAME size ({value0}).", { value0: detectedDeviseSize === "d" ? "1200 x 500" : "800 x 500" }),
              elakayAutoText("h_282430df5b5400", "✅ The first one will be kept."),
              elakayAutoText("h_c53709b9da64ec", "❌ The other one will be ignored."),
              "",
              elakayAutoText("h_bb6ecd6faa9cba", "Please add the other size: {value0}.", { value0: need }),
              "",
              elakayAutoText("h_3ed8813d8693d1", "Current images:"),
              elakayAutoText("h_4d192bfb1dfcc5", "• Desktop: {value0} {value1}", { value0: currentDesktop, value1: currentDesktop ? "✅" : "❌" }),
              elakayAutoText("h_08c8cb1facd1c0", "• Mobile: {value0} {value1}", { value0: currentMobile, value1: currentMobile ? "✅" : "❌" }),
              ""
            ]);

            filesProcessed++;
            if (filesProcessed === files.length) finalize();
            return;
          }
        }

        // -----------------------------------------
        // 3) Build file object & push to batch
        // -----------------------------------------
        const fileobj = {
          file,
          name: file.name,
          type: file.type,
          size: file.size,
          src: reader.result,
          naturalW,
          naturalH,
          deviseSize: detectedDeviseSize,
        };

        arrPhotos.push(fileobj);

        filesProcessed++;
        if (filesProcessed === files.length) finalize();
      };

      img.src = reader.result;
    };

    reader.readAsDataURL(file);
  }
};

  const handlefilechange = (e) => {
    let files = e.target.files;
    handleFiles(files);
  };

  const handledelete = (imgIndex) => {
    setPost((prev) => ({
      ...prev,
      photos: prev.photos.filter((_, i) => i !== imgIndex),
    }));
  };

  const handlehighlight = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(true);
  };

  const handleunhighlight = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
  };

  const handledrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
    let dt = e.dataTransfer;
    let files = dt.files;
    handleFiles(files);
  };

  const imagesSeletCSS = (a = 0) => {
    let x = { border: "2px solid green" };
    let y = { border: "4px solid red" };
    return maxTailleImg < a ? y : x;
  };

  // ✅ handleSubmit pour Add_Update_ImgPub
  const handleSubmit = async () => {
    try {
      if (!photos || photos.length === 0) {
        setError([elakayAutoText("h_c334c6905fbd4e", "No images to upload")]);
        return;
      }

      const isDualImage = [3, 4, 5].includes(pubInfo.refIndex);

      if (isDualImage && photos.length !== 2) {
        setError([
          elakayAutoText("h_34a081081db4c0", "{value0} requires 2 images (Desktop + Mobile).", { value0: refObjName[refObj.indexOf(pubInfo.nameref)] }),
          elakayAutoText("h_e6c8959ec1df93", "You uploaded {value0} image(s).", { value0: photos.length })
        ]);
        return;
      }

           // Mapper les photos avec toutes les métadonnées
            const photosMapped = photos?.map((f) => ({
                file: f.file,
                naturalW: f.naturalW,    // 1200 ou 800
                naturalH: f.naturalH,    // 500 ou 500
                n : pubInfo.refIndex, // 0, 1, 2, 3, 4, 5
                deviseSize: f.deviseSize // 'd' ou 'm'
            })) || [];

      // ✅ Créer FormData
      // const formData = new FormData();
      
      // if (post.catID) {
      //   formData.append('catID', post.catID);
      // }

      // photos.forEach((p, i) => {
      //   formData.append('photos', p.file);
      //   formData.append(`w_${i}`, p.naturalW);
      //   formData.append(`h_${i}`, p.naturalH);
      //   formData.append(`n_${i}`, pubInfo.refIndex);
      //   formData.append(`deviseSize_${i}`, p.deviseSize);
      // });

      // ✅ Appel API Add_Update_ImgPub
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/pub/add`, {
      //   method: 'POST',
      //   headers: { 'Authorization': `Bearer ${token}` },
      //   body: formData
      // });
 const data = await Add_ImgPub(token, photosMapped, post.catID);
      

      if (!data || !data.success) {
        setError(data?.errors?.map(e => e.message) || [elakayAutoText("h_ad0d0603e2aad1", "Upload failed")]);
        return;
      }

      // ✅ Success
      setError(null);
      setPost({ catID: "", photos: [] });
      loadingUserPub(userID);

    } catch (err) {
      console.error('handleSubmit error:', err);
      setError([err.message || elakayAutoText("h_831b916850bbfe", "Unexpected error")]);
    }
  };

  // ✅ ViewImageModal (style exact Pub1200X500)
  const ViewImageModal = () => {
    if (!viewImageModal) return null;

    return (
      <Modal
        show={!!viewImageModal}
        onHide={() => setViewImageModal(null)}
        fullscreen
        contentClassName="pub-modal-shell"
        backdropClassName="pub-modal-backdrop-bs"
      >
        <Modal.Body className="pub-modal-body" onClick={() => setViewImageModal(null)}>
          <div className="pub-modal-content" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="pub-modal-close" onClick={() => setViewImageModal(null)}>
              <MdClose />
            </button>
            <img
              className="pub-modal-image"
              src={viewImageModal.src}
              alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t004}
            />
            <div className="pub-modal-caption">
              <p>
                {viewImageModal.deviseSize === "d" ? elakayAutoText("h_c27eb279275995", "📺 Desktop & Tablet") : elakayAutoText("h_14ec55e192af50", "📱 Mobile")}
              </p>
              <p>{viewImageModal.naturalW} x {viewImageModal.naturalH}{__elakayText("t014", "pixels")}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

const formatBytes = (bytes = 0) => {
  if (!bytes) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
};

const previewCardStyle = (img) => ({
  aspectRatio: img?.naturalW && img?.naturalH ? `${img.naturalW} / ${img.naturalH}` : "1 / 1",
});

  const ImagesForm = () => {
    const isDualImage = [3, 4, 5].includes(pubInfo.refIndex);

    return (
      <div className="m-3">
        <form encType="multipart/form-data">
<div className="pub-preview-grid">
  {photos?.length > 0 &&
    photos.map((a, i) => (
      <div key={i} className="pub-preview-card" style={previewCardStyle(a)}>

        {/* delete */}
        <button type="button" className="pub-preview-delete" onClick={() => handledelete(i)}>
          ×
        </button>

        {/* file size */}
        <span className="pub-preview-filesize">{formatBytes(a.size)}</span>

        <img className="pub-preview-img" src={a.src} alt={a.name} />

        {/* device + dimensions */}
        <span className={`pub-preview-devicebadge pub-preview-devicebadge--${a.deviseSize === "d" ? "desktop" : "mobile"}`}>
          {a.deviseSize === "d" ? elakayAutoText("h_5398fafb6beb2c", "📺 Desktop") : elakayAutoText("h_14ec55e192af50", "📱 Mobile")} ({a.naturalW}×{a.naturalH})
        </span>

        {/* edit overlay */}
        {editImageIndex === i && (
          <div className="pub-preview-editoverlay">
            <MdEdit />
          </div>
        )}
      </div>
    ))}
</div>

          <ImageSizeSelector />

          <div className="custom-form-group">
            {checkIfAddImg(pubInfo["nameref"]) ? (
              !onlyFamilly(pubInfo["nameref"]) ? (
                inputError(infoSource.laguangeElakay("title", infoSource.languageAPI).comingSoon, true)
              ) : (
                inputError(language(infoSource, "label", "dragDropImgSelc"), false)
              )
            ) : longPub < pubInfo.maxImgSize ? (
              !onlyFamilly(pubInfo["nameref"]) ? (
                inputError(infoSource.laguangeElakay("title", infoSource.languageAPI).comingSoon, true)
              ) : (
                <div
                  className={highlight ? "custom-file-drop-area highlight" : "custom-file-drop-area"}
                  onDragEnter={handlehighlight}
                  onDragOver={handlehighlight}
                  onDragLeave={handleunhighlight}
                  onDrop={handledrop}
                >
                  <input
                    type="file"
                    name="photos"
                    multiple
                    id="filephotos"
                    onChange={handlefilechange}
                    accept="image/*"
                  />

                  <label htmlFor="filephotos">
                    {longPub}{" "}
                    {infoSource.laguangeElakay("label", infoSource.languageAPI).imagesof}{" "}
                    {pubInfo.maxImgSize}
                    <br />
                    {infoSource.laguangeElakay("Button", infoSource.languageAPI).add}{" "}
                    {pubInfo.maxImgSize - longPub}{" "}
                    {infoSource.laguangeElakay("label", infoSource.languageAPI).morimagesnot}
                    <br />
                    {infoSource.laguangeElakay("label", infoSource.languageAPI).dragDrop}{" "}
                  </label>
                </div>
              )
            ) : (
              inputError(language(infoSource, "label", "canDragDrop"), false)
            )}
          </div>
        </form>

        <ErrorAlert error={error} setError={setError} duration={10000} />

        <div className="mt-3">
          {(() => {
            if (isDualImage) {
              const desktopCount = photos.filter(p => p.deviseSize === 'd').length;
              const mobileCount = photos.filter(p => p.deviseSize === 'm').length;
              const hasComplete = desktopCount === 1 && mobileCount === 1;

              return hasComplete ? (
                <button type="button" className="pub-submit-btn" onClick={handleSubmit}>{__elakayText("t015", "Submit")}</button>
              ) : (
                <button type="button" className="pub-submit-btn" disabled>{__elakayText("t015", "Submit")}{!hasComplete && `(${desktopCount}/1 Desktop, ${mobileCount}/1 Mobile)`}
                </button>
              );
            }

            return photos.length > 0 ? (
              <button type="button" className="pub-submit-btn" onClick={handleSubmit}>{__elakayText("t015", "Submit")}</button>
            ) : (
              <button type="button" className="pub-submit-btn" disabled>{__elakayText("t015", "Submit")}</button>
            );
          })()}
        </div>
      </div>
    );
  };

  const checkedListe = (value) => {
    const labelIndex = refObjName.indexOf(value);
    return PUB_SHOP_SECTIONS.find((item) => item.refIndex === labelIndex)?.slug === activeSection;
  };

  const selectProfitTargetPrice = () => (
    <div className="pub-type-nav">
      {refObjName?.length > 0 &&
        refObjName.map((ob, i) => (
          i > 0 && (
            <label
              key={i}
              htmlFor={"refObjName_" + ob}
              className={`pub-type-nav-item ${checkedListe(ob) ? "is-active" : ""}`}
            >
              <input
                type="radio"
                className="pub-type-nav-radio"
                onChange={() => handSelectedPub(i)}
                checked={checkedListe(ob)}
                id={"refObjName_" + ob}
              />
              {ob}
            </label>
          )
        ))}
    </div>
  );

  const selectedGauche = () => (
    <div className="pub-type-nav">
      {getCategoriesUser?.map((cat, i) => (
        <label
          key={i}
          htmlFor={cat._id}
          className={`pub-type-nav-item ${post.catID === cat._id ? "is-active" : ""}`}
        >
          <input
            type="radio"
            className="pub-type-nav-radio"
            onChange={() => handSelectedCatId(cat._id)}
            checked={post.catID === cat._id}
            name="catSelected"
            id={cat._id}
          />
          <span style={{ flex: 1 }}>{cat.name.slice(0, -1).join(", ")}</span>
          {post.catID === cat._id && (
            <img style={{ width: "32px", borderRadius: "6px" }} src={imgProductLakay} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t005} />
          )}
        </label>
      ))}
    </div>
  );

  const images = [ElakayAccount, RoyaltyUser, SellerPub1];

  // Preview of the shop banner: same component identity as the real one
  // (Promotional Banner in Animation Settings -> Swiper Settings).
  const SliderPubUser = () => {
    const swp = useElakaySwiper("promoBanner", { autoNavigation: Boolean(infoSource?.navigation), slideCount: images?.length || 0 });
    return (
    <div className="mt-2">
      <Swiper
        key={swp.key}
        {...swp.swiperProps}
        className={`mySwiper ${swp.className}`}
        style={swp.style}
      >
        {images?.map((each, index) => (
          <SwiperSlide key={index}>
            <img style={{ width: "100%", maxHeight: "450px" }} src={each} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t006} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    );
  };

  const prodFollowALL = () => (
    <div className="card m-4 p-0">
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td className="w-25 p-0">
              <div className="d-grid gap-2 mx-auto">
                <button className="m-1 py-3 px-0 btn btn-outline-dark rounded-4 shadow-lg">
                  {infoSource.laguangeElakay("Button", infoSource.languageAPI).viewlakay}
                </button>
              </div>
            </td>
            <td>
              <img style={{ width: "100%", maxHeight: "200px" }} src={imgLakay} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t007} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const AdminFallow = () => (
    <div className="card m-1 p-1 m-4">
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <img style={{ width: "100%", maxHeight: "200px" }} src={imgLakay} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t008} />
            </td>
            <td className="w-25 p-0">
              <div className="d-grid gap-2 mx-auto">
                <button className="m-1 py-3 px-0 btn btn-outline-dark rounded-4 shadow-lg">
                  {infoSource.laguangeElakay("Button", infoSource.languageAPI).viewlakay}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const showAlliste = () => (
    <div className="container-fluid px-2 px-md-4">
      <div className="row d-flex align-items-start justify-content-center">
        <div className="col-12 col-lg-5">{selectProfitTargetPrice()}</div>
        <div className="col-12 col-lg-7">
          {"PubImgFollow" === pubInfo.nameref && (
            <img className="rounded mx-auto d-block" style={{ width: "50%" }} src={imgProductLakay} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t009} />
          )}
          {selectedGauche()}
          {"viewImagAdmin" === pubInfo.nameref && <AdminFallow />}
          {"viewImagforFollow" === pubInfo.nameref && prodFollowALL()}
          {"sliderShop" === pubInfo.nameref && <SliderPubUser />}
        </div>
      </div>
    </div>
  );

  const deleteimgPubFonc = (n, urlImg) => {
    deleteImgPub(token, n, urlImg).then((data) => {
      if (data) {
        setPost({ catID: "", photos: [] });
        loadingUserPub(userInfo._id);
      }
    });
  };

  const showPubImgFollow = () => (
    getUserPub?.PubImgFollow?.urlImg && (
      <div className="container-fluid mt-3 mb-3 px-2 px-md-4">
        <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
          <h4>{refObjName[1]}</h4>
        </div>
        <Row xs={2} sm={3} md={4} lg={5} xl={6}>
          <div className="p-1">
            <div style={{ position: "relative", overflow: "hidden", width: "100%" }}>
              <img className="rounded" src={getElakayImageLoadUrl(toImageUrl(getUserPub.PubImgFollow.urlImg), { width: 300 })} loading="lazy" decoding="async" alt={refObjName[1]} style={{ width: "100%" }} />
              <div style={{ position: "absolute", top: 0, right: 0, fontSize: "25px", color: "blue" }}>
                <MdDeleteForever onClick={() => deleteimgPubFonc(1, getUserPub.PubImgFollow.urlImg)} />
              </div>
            </div>
          </div>
        </Row>
      </div>
    )
  );

  const showPubCategory = () => (
    getUserPub?.PubCategory?.length > 0 && (
      <div className="container-fluid mt-3 mb-3 px-2 px-md-4">
        <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
          <h4>{refObjName[2]}</h4>
        </div>
        <Row xs={2} sm={3} md={4} lg={5} xl={6}>
          {getUserPub.PubCategory.map((p, i) => (
            <div key={i} className="p-1">
              <div style={{ position: "relative", overflow: "hidden", width: "100%" }}>
                <img className="rounded" src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 300 })} loading="lazy" decoding="async" alt={`${refObjName[2]}: ${i}`} style={{ width: "100%" }} />
                <div style={{ position: "absolute", top: 0, right: 0, fontSize: "25px", color: "blue" }}>
                  <MdDeleteForever onClick={() => deleteimgPubFonc(2, p.urlImg)} />
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    )
  );

  const showImagAdmin = () => (
    getUserPub?.viewImagAdmin?.urlImg && (
      <div className="container-fluid mt-3 mb-3 px-2 px-md-4">
        <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
          <h4>{refObjName[3]}</h4>
        </div>
        <Row xs={2} md={3}>
          <div className="p-1">
            <h6>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t010}</h6>
            <div style={{ position: "relative", overflow: "hidden", width: "100%" }}>
              <img className="rounded" src={getElakayImageLoadUrl(toImageUrl(getUserPub.viewImagAdmin.urlImg), { width: 300 })} loading="lazy" decoding="async" alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t011} style={{ width: "100%" }} />
              <div style={{ position: "absolute", top: 0, right: 0, fontSize: "25px", color: "blue" }}>
                <MdDeleteForever onClick={() => deleteimgPubFonc(3, getUserPub.viewImagAdmin.urlImg)} />
              </div>
            </div>
          </div>
        </Row>
      </div>
    )
  );

  const showImagforFollow = () => (
    getUserPub?.viewImagforFollow?.urlImg && (
      <div className="container-fluid mt-3 mb-3 px-2 px-md-4">
        <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
          <h4>{refObjName[4]}</h4>
        </div>
        <Row xs={2} md={3}>
          <div className="p-1">
            <h6>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t012}</h6>
            <div style={{ position: "relative", overflow: "hidden", width: "100%" }}>
              <img className="rounded" src={getElakayImageLoadUrl(toImageUrl(getUserPub.viewImagforFollow.urlImg), { width: 300 })} loading="lazy" decoding="async" alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addPubShop.t013} style={{ width: "100%" }} />
              <div style={{ position: "absolute", top: 0, right: 0, fontSize: "25px", color: "blue" }}>
                <MdDeleteForever onClick={() => deleteimgPubFonc(4, getUserPub.viewImagforFollow.urlImg)} />
              </div>
            </div>
          </div>
        </Row>
      </div>
    )
  );

  const showSliderShop = () => (
    getUserPub?.sliderShop?.length > 0 && (
      <div className="container-fluid mt-3 mb-3 px-2 px-md-4">
        <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
          <h4>{refObjName[5]}</h4>
        </div>
        <Row xs={2} md={3}>
          {getUserPub.sliderShop.map((p, i) => (
            <div key={i} className="p-1">
              <div style={{ position: "relative", overflow: "hidden", width: "100%" }}>
                <img className="rounded" src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 300 })} loading="lazy" decoding="async" alt={`${refObjName[5]}: ${i}`} style={{ width: "100%" }} />
                <div style={{ position: "absolute", top: 0, right: 0, fontSize: "22px", color: "blue", cursor: "pointer" }}>
                  <MdDeleteForever onClick={() => deleteimgPubFonc(5, p.urlImg)} />
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    )
  );

  return (
    <div className="w-100">
      {/* Main Shop Slider Source: image slider (below) or an Elakay Swiper. */}
      {activeSection === "slider-shop" && (
        <ShopHeroSourcePanel infoSource={infoSource} shopUrl={userID ? `/lakay-ShopSeller/${userInfo?.publicId || userID}` : null} />
      )}
      <div className="pub-section-card">
        {showAlliste()}
      </div>

      <div className="pub-section-card">
        {ImagesForm()}
      </div>

      {/* {showPubImgFollow()} */}
      {/* {showPubCategory()} */}
      {/* {showImagAdmin()} */}
      {/* {showImagforFollow()} */}
      {/* {showSliderShop()} */}
      <div className="pub-section-card">
        <Userpubgallery
          toImageUrl={toImageUrl}
          getUserPub={getUserPub}
          infoSource={infoSource}
          refObjName={refObjName}
          deleteimgPubFonc={deleteimgPubFonc}
        />
      </div>

      <ViewImageModal />

    </div>
  );
};

export default PubShop;
